import { useEffect } from 'react';

import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { MetaTags, useMutation } from '@redwoodjs/web';

import { GET_SAGE_TOKEN } from 'src/graphql/mutations/getSageToken.mutation';
import { LogError } from 'src/lib/error-logger';

import { showSuccessToast } from '../../components/Toasts/toast';

const HomePage = () => {
    const navigate = useNavigate();
    const [getSageToken] = useMutation(GET_SAGE_TOKEN, {
        onCompleted: (data) => {
            const { status } = data.getSageToken;
            if (status === 'created') {
                showSuccessToast('Sage system user successfully created!');
            } else if (status === 'updated') {
                showSuccessToast('Sage system access token successfully re-initialised!');
            }
        },
    });

    useEffect(() => {
        const fetchSageToken = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');

            if (code) {
                try {
                    await getSageToken({ variables: { code } });
                    navigate('/');
                } catch (error) {
                    LogError(error);
                }
            }
        };

        fetchSageToken();
    }, [getSageToken, navigate]);

    return (
        <>
            <MetaTags title="Home" description="Home page" />

            <Box sx={{ width: '100%', padding: 2 }}>
                <Typography variant="h1">Dashboard</Typography>
            </Box>
        </>
    );
};

export default HomePage;
